export const checkRoles = (...args) => {
  let roles = localStorage.roles || "[]";
  roles = JSON.parse(roles)
  if (!Array.isArray(roles)) {
    roles = [roles]
  }
  return args.some(role => {
    return roles.includes(role)
  })
}